import React from 'react';
import ReactMarkdown from 'react-markdown';
import '../styles/Description.css';

interface DescriptionProps {
  content: string;
}

const Description: React.FC<DescriptionProps> = ({ content }) => {
  if (!content) {
    return null;
  }

  return (
    <section className="description">
      <div className="description-container">
        <div className="description-content">
          <ReactMarkdown>{content}</ReactMarkdown>
        </div>
      </div>
    </section>
  );
};

export default Description;
